interface Action<Type extends string> {
  type: Type;
}

interface ActionWithPayload<Type extends string, Payload> {
  type: Type;
  payload: Payload;
}

type ActionReturnType<T, P> =
  | {
      type: T;
      payload?: undefined;
    }
  | {
      type: T;
      payload: P;
    };

/* eslint-disable no-redeclare */
export function createAction<Type extends string>(type: Type): Action<Type>;
export function createAction<Type extends string, Payload>(
  type: Type,
  payload: Payload
): ActionWithPayload<Type, Payload>;
export function createAction<Type, Payload>(
  type: Type,
  payload?: Payload
): ActionReturnType<Type, Payload> {
  return payload === undefined ? { type } : { type, payload };
}
/* eslint-enable no-unused-vars */

// thunk-actionを除外
export type ActionsUnion<
  A extends {
    [actionCreator: string]: (...args: any[]) => any;
  }
> = Exclude<ReturnType<A[keyof A]>, (...args: any[]) => Promise<void>>;
